import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=10018b57&scoped=true"
import script from "./SimplePagination.vue?vue&type=script&lang=js"
export * from "./SimplePagination.vue?vue&type=script&lang=js"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=10018b57&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10018b57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10018b57')) {
      api.createRecord('10018b57', component.options)
    } else {
      api.reload('10018b57', component.options)
    }
    module.hot.accept("./SimplePagination.vue?vue&type=template&id=10018b57&scoped=true", function () {
      api.rerender('10018b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SimplePagination.vue"
export default component.exports